import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Button, Card, CardColors, Icon, Image, Separator, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const GoalSettingIntro = ({
  goBack,
  goToNextStep,
}: {
  goBack: (newScreen: string | null, replace?: boolean | undefined) => void
  goToNextStep: () => void
}) => {
  return (
    <div className="mt-5 flex flex-col items-center mx-auto w-5/8 md:w-7/8 lg:w-7/8">
      <Text variant={TypographyStyles.DISPLAY_MD} className="mb-4">
        Understanding Financial Goals
      </Text>
      <Text variant={TypographyStyles.BODY_SM} className="mb-2">
        Effective financial planning starts with setting clear, measurable goals
        for income, expenses, and profit. This exercise will guide you through
        establishing these targets for the current year.
      </Text>

      <div className="flex gap-1 items-center">
        <Card color={CardColors.LEVEL_1} className="w-1/2 items-center">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/coins-stack-arrow.svg"
            alt="coin stack"
            width={80}
          />
          <br />
          <Text variant={TypographyStyles.H1}>Income</Text>
          <br />
          <Text variant={TypographyStyles.BODY_SM}>
            This includes session fees, group therapy, workshops, insurance
            reimbursements, and any specialized services you offer.
          </Text>
        </Card>
        <Icon icon={regular('minus')} size="2x" />
        <Card color={CardColors.LEVEL_1} className="w-1/2">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/split-money.svg"
            alt="split money"
          />
          <br />
          <Text variant={TypographyStyles.H1}>Expenses</Text>
          <br />
          <Text variant={TypographyStyles.BODY_SM}>
            The costs of running your therapy practice.
          </Text>
        </Card>
      </div>

      <Icon icon={regular('equals')} size="2x" />
      <Card color={CardColors.LEVEL_1} className="w-full flex mb-10">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/coins-stack-sparkle.svg"
          alt="coin stack with sparkles"
          width={80}
          className="mr-4"
        />
        <div>
          <Text variant={TypographyStyles.H1}>Profit</Text>
          <br />
          <Text variant={TypographyStyles.BODY_SM}>
            This is your personal income before taxes. It funds your living
            expenses, retirement contributions, and other financial goals.
          </Text>
        </div>
      </Card>

      <Separator className="mt-10" />
      <div className="w-full flex justify-between mt-6">
        <Button onClick={() => goBack(null)} variant="secondary">
          Back
        </Button>
        <Button onClick={goToNextStep} iconRight={regular('chevron-right')}>
          Next
        </Button>
      </div>
    </div>
  )
}
